<template>
  <div class="user-list-container">
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="类型编码" label-col-flex="60px">
              <a-input v-model="queryForm.typeCode" placeholder="请输入类型编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="类型名称" label-col-flex="60px">
              <a-input v-model="queryForm.typeName" placeholder="请输入类型名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="状态" label-col-flex="60px">
              <a-select v-model="queryForm.status" placeholder="请选择状态" class="input" allow-clear>
                <a-option value="">全部</a-option>
                <a-option value="true">启用</a-option>
                <a-option value="false">禁用</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <div>
              <a-space>
                <a-button type="primary" @click="handleQuery" :loading="loading">
                  <template #icon>
                    <icon-search style="stroke: #fff"/>
                  </template>
                  搜索
                </a-button>
                <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
                <!--              <a-button type="text" @click="()=>{collapsed = !collapsed}">-->
                <!--                <template #icon>-->
                <!--                  <icon-down v-if="collapsed" />-->
                <!--                  <icon-up v-else />-->
                <!--                </template>-->
                <!--                {{ collapsed ? '展开' : '收起' }}-->
                <!--              </a-button>-->
              </a-space>
            </div>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>
    <a-space/>
    <!-- 公司抬头信息表格 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <!-- 标题栏 -->
      <template #header>
        <a-row>
          <a-col flex="200px">
            <span class="glass-card__title">门店类型列表</span>
          </a-col>
          <a-col flex="auto"/>
        </a-row>
      </template>

      <!-- 公司抬头信息数据表格 -->
      <a-table
          :columns="allColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :scroll="{ x: 1000 }"
      >

        <template #status="{ record }">
          <a-tag :color="getStatusColor(record.status)">
            {{ getStatusText(record.status) }}
          </a-tag>
        </template>

        <template #createTime="{ record }">
          {{ formatDate(record.createTime) }}
        </template>

        <template #updateTime="{ record }">
          {{ formatDate(record.updateTime) }}
        </template>
        <!--        TODO 操作列暂时不用-->
        <!--        <template #action="{ record }">-->
        <!--&lt;!&ndash;          <a-space>&ndash;&gt;-->
        <!--            <a-button type="text" size="mini" @click="editCustomer(record)">-->
        <!--              <template #icon>-->
        <!--                <icon-edit/>-->
        <!--              </template>-->
        <!--              编辑-->
        <!--            </a-button>-->
        <!--            <a-popconfirm-->
        <!--                content="确定要删除该客户吗？"-->
        <!--                @ok="deleteCustomer(record)"-->
        <!--                ok-text="确定"-->
        <!--                cancel-text="取消"-->
        <!--            >-->
        <!--              <a-button type="text" size="mini"  status="danger">-->
        <!--                <template #icon>-->
        <!--                  <icon-delete/>-->
        <!--                </template>-->
        <!--                删除-->
        <!--              </a-button>-->
        <!--            </a-popconfirm>-->
        <!--&lt;!&ndash;          </a-space>&ndash;&gt;-->
        <!--        </template>-->
      </a-table>

      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          v-model:current="pagination.current"
          v-model:page-size="pagination.size"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>

  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import {getCustomerStoreTypePage} from '@/apis/customer-data'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import {
  IconSearch,
  IconDown,
  IconUp,
  IconPlus,
  IconSettings,
  IconRefresh,
  IconEdit,
  IconLock,
  IconDelete
} from '@arco-design/web-vue/es/icon'
import {Message} from "@arco-design/web-vue";
import {timestampNumber2dateString} from "@/utils/date-util";

// 条件查询表单折叠
const collapsed = ref(true)

// 条件查询表单数据
const queryForm = ref({
  typeCode: '',
  typeName: '',
  status: '',
})

// 公司抬头信息数据
let pagination = ref({
  records: [],
  current: 1,
  size: 10,
  pages: 0,
  total: 0
})
// 加载状态
const loading = ref(false)

// 所有列定义
const allColumns = ref([
  // {title: 'ID', dataIndex: 'id', width: 80, required: true},
  {title: '排序', dataIndex: 'sortOrder', width: 80,sortable: { sortDirections: ['ascend', 'descend'] }, ellipsis: true, tooltip: true, fixed: 'left', required: true},
  {title: '类型编码', dataIndex: 'typeCode', width: 120, ellipsis: true, tooltip: true, fixed: 'left', required: true},
  {title: '类型名称', dataIndex: 'typeName', width: 120, ellipsis: true, tooltip: true, fixed: 'left', required: true},
  {title: '类型描述', dataIndex: 'description', width: 130, ellipsis: true,tooltip: true},
  {title: '状态', dataIndex: 'status', width: 120, ellipsis: true, tooltip: true, slotName: 'status',},
  {title: '创建时间', dataIndex: 'createTime', width: 160, ellipsis: true, tooltip: true, slotName: 'createTime',},
  {title: '更新时间', dataIndex: 'updateTime', width: 160, ellipsis: true, tooltip: true, slotName: 'updateTime',},
  // TODO 操作列暂时不用
  // {title: '操作', dataIndex: 'action', width: 180, slotName: 'action', fixed: 'right', required: true, align: 'center', cellStyle:{paddingLeft: 0,paddingRight:0}, bodyCellStyle:{paddingLeft: 0,paddingRight:0}}
])

// 获取表格数据
const fetchTableData = () => {
  loading.value = true;
  getCustomerStoreTypePage({
    ...queryForm.value,
    current: pagination.value.current,
    size: pagination.value.size
  }).then(response => {
    // console.log(response)
    loading.value = false;
    if (response.code === 0) {
      pagination.value = response.data;
      // console.log(pagination.value)
    } else {
      Message.error(response.message);
    }
  }).catch(error => {
    Message.error(error.message)
  })
}

// 处理查询
const handleQuery = () => {
  pagination.current = 1
  fetchTableData()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(queryForm.value).forEach(key => {
    queryForm.value[key] = ''
  })
  handleQuery()
}

// 处理页码变化
const handlePageChange = (page) => {
  fetchTableData()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.current = 1
  fetchTableData()
}

// 格式化方法
const getStatusText = (status) => {
  if(null == status){
    return '未知'
  } else {
    return status ? '启用' : '禁用'
  }
}
const getStatusColor = (status) => {
  if(null == status){
    return '未知'
  } else {
    return status ? 'green' : 'red'
  }
}
const formatDate = (dateString) => {
  // if (!dateString) return '-'
  // const date = new Date(dateString)
  // return date.toLocaleString('zh-CN')
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2dateString(dateString)}

// 组件挂载时获取数据
onMounted(() => {
  fetchTableData()
})
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}
</style>